export default __webpack_public_path__ + "static/media/user.efc4904d.png";